module.exports = __webpack_public_path__ + "website/img/baidu-cloud.a94f7a32.png";